import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Seo from "../../components/Seo";
import { EmptyState, LoadMore, PageHeader, Spinner, usePagedList } from "../../components/lawyer/LawyerUi";
import emptyArt from "../../assets/images/myPostsEmpty.png";
import { userService } from "../../services/userApi";

export const QuestionStatus = ({ q }) => {
  if (String(q.status || "").toLowerCase() === "closed") return <span className="lwp-status lwp-status-cancelled">Closed</span>;
  if (Number(q.answers_count) > 0) return <span className="lwp-status lwp-status-ended">Answered</span>;
  return <span className="lwp-status lwp-status-pending">Awaiting answers</span>;
};

// "My Request" tab — the questions this client has posted to lawyers.
const UserRequests = () => {
  const list = usePagedList((page) => userService.getMyQuestions(page), (d) => d.questions, []);

  return (
    <div className="lwp-page">
      <Seo title="My Posts | Legal Platform" noindex />
      <PageHeader
        title="My Posts"
        backTo="/user/dashboard"
        actions={
          list.items.length > 0 && (
            <Link to="/user/requests/new" className="lwp-pill-btn">
              <i className="bi bi-plus-lg" />
              <span>New Question</span>
            </Link>
          )
        }
      />

      {list.loading ? (
        <Spinner />
      ) : list.meta.error ? (
        <EmptyState icon="bi-exclamation-circle" text={list.meta.error} />
      ) : list.items.length === 0 ? (
        <div className="usp-posts-empty">
          <img src={emptyArt} alt="" />
          <Link to="/user/requests/new" className="lwp-btn">
            Create New Question
          </Link>
        </div>
      ) : (
        <>
          <ul className="lwp-card-list">
            {list.items.map((q) => (
              <li key={q.id}>
                <Link to={`/user/requests/${q.id}`} className="usp-question-row">
                  <span className="usp-question-body">
                    <strong>{q.question}</strong>
                    <span className="lwp-meta">
                      {q.jurisdiction?.name && (
                        <>
                          <i className="bi bi-geo-alt" /> {q.jurisdiction.name} ·{" "}
                        </>
                      )}
                      {moment(q.created_at).isValid() ? moment(q.created_at).format("D MMM YYYY") : ""}
                    </span>
                  </span>
                  <span className="usp-question-side">
                    <QuestionStatus q={q} />
                    <span className="usp-question-count">
                      <i className="bi bi-chat-left-text" /> {q.answers_count || 0}
                      {Number(q.unread_answers) > 0 && <span className="lwp-unread">{q.unread_answers}</span>}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <LoadMore list={list} />
        </>
      )}
    </div>
  );
};

export default UserRequests;
